export const blockIconsActionDashboard = (
	<span className='material-symbols-outlined'>dashboard</span>
);
